import { render, staticRenderFns } from "./UpgradePlan.vue?vue&type=template&id=1fa3885a&scoped=true"
import script from "./UpgradePlan.vue?vue&type=script&lang=js"
export * from "./UpgradePlan.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlan.vue?vue&type=style&index=0&id=1fa3885a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa3885a",
  null
  
)

export default component.exports